import { render } from "./ChatAssistant.vue?vue&type=template&id=5cf70c38&scoped=true"
import script from "./ChatAssistant.vue?vue&type=script&lang=js"
export * from "./ChatAssistant.vue?vue&type=script&lang=js"

import "./ChatAssistant.vue?vue&type=style&index=0&id=5cf70c38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf70c38"]])

export default __exports__